var React = require('react');

function IconHandUpO (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M181.6 528.5c-20.4 16.8-25.6 45.7-12.2 68.5l159.3 271.7c8.8 14.9 24.2 23.7 41.6 23.7h443.2c26.5 0 48.2-21.7 48.4-48.4l2.3-371.5c0-16.2-12.2-29.8-28.4-31.4l-329.4-16c-33.4-2.3-59.4-30.5-59.1-64.1l1.8-183c.1-13.2-4.9-25.6-14.1-34.9-9.1-9.2-21.3-14.4-34.2-14.4-27.2 0-49.1 21.9-49.1 48.8v498.3L254.5 536c-15.5-21.4-48.2-26.7-70-10.2l-2.9 2.7zm188.7 427.6c-39.5 0-76.5-21.2-96.4-55.2L114.5 629.2c-28.7-49-18.4-110.6 24.3-147.7l3.5-3.3c41.6-34.2 105.6-33 145.8 1.2V177.6c0-62 50.4-112.4 112.4-112.4 30.4 0 58.6 11.8 79.8 33.2 21.3 21.5 32.8 50.1 32.6 80.4l-1.8 183 330.2 16.1c49.8 5 86.6 45.8 86.6 95l-2.3 371.7c-.4 61.6-50.7 111.7-112 111.7H370.3z"}));
}

IconHandUpO.displayName = "IconHandUpO";

IconHandUpO.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconHandUpO;

IconHandUpO.default = IconHandUpO;
